import React, { useContext } from 'react'
import { useNavigate, useLocation, useParams } from 'react-router-dom'
import { LanguageContext } from '../i18n/LanguageContext'

function WithNavigate ({ Component }) {
  const navigate = useNavigate()
  const location = useLocation()
  const params = useParams()
  const { language } = useContext(LanguageContext)
  return <Component navigate={navigate} location={location} params={params} language={language} />
}

export default WithNavigate
